/* © 2016 Andrew Pinkham
 * This code is licensed under the Simplified BSD License.
 * https://opensource.org/licenses/BSD-2-Clause
 * Inspired by code from Tyler McGinnis
 * on Github under the ISC License.
 * https://github.com/tylermcginnis/github-notetaker-egghead
 * https://opensource.org/licenses/ISC
 */

export default (obj, deleteKey) =>
  Object.keys(
    obj
  ).filter(
    key => key !== deleteKey
  ).reduce(
    (accumulator, key) => Object.assign({}, accumulator, { [key]: obj[key] }),
    {}
  )



// WEBPACK FOOTER //
// ./src/utils/removeKeyFromObject.js